import React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { AccessibleIcon } from "@radix-ui/react-accessible-icon";
import "./Modal.scss";
import { CircleX } from "lucide-react";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  title,
}) => {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="modal__overlay">
          <Dialog.Content className="modal__container">
            <div className="modal__header">
              {title ? (
                <Dialog.Title className="modal__title">{title}</Dialog.Title>
              ) : null}
              <AccessibleIcon label="Cerrar Modal">
                <Dialog.Close className="modal__close-button">
                  <CircleX />
                </Dialog.Close>
              </AccessibleIcon>
            </div>
            <div className="modal__content">{children}</div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
